import React from "react";
import testimonials from "../data/testimoniasData";
import "../styles/Testimonials.css";
import Footer from "../components/Footer";


const TestimonialsPage = () => {
  return (
    <div className="testimonials-page">
      <section className="testimonials-page-section">
        <h2 className="testimonials-page-title">Hear from the Healed</h2>
        <p className="testimonials-page-subtitle">
          Happy patients share their kind words and experiences.
        </p>

        <div className="testimonials-page-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonials-page-card">
              <div className="testimonials-page-card-header">
                <div className="testimonials-page-user">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="testimonials-page-user-img"
                  />
                  <div>
                    <div className="testimonials-page-user-name">
                      {testimonial.name}
                    </div>
                    <div className="testimonials-page-user-role">
                      {testimonial.role}
                    </div>
                  </div>
                </div>
                <div className="testimonials-page-rating">
                  {"★".repeat(testimonial.rating)}
                  {"☆".repeat(5 - testimonial.rating)}
                </div>
              </div>
              <div className="testimonials-page-treatment">
                {testimonial.treatment}
              </div>
              <p className="testimonials-page-feedback">{testimonial.feedback}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;
